export const authStorageToken = 'authToken';
export const authStorageUser = 'authUser';
export const activeComponentKey = 'component'
export const clientKey = 'client'
export const clientPosKey = 'clientPos'